// extracted by mini-css-extract-plugin
export var attachment = "_oc-a";
export var emailContainer = "_oc-4";
export var emailContentPaddedContainer = "_oc-b";
export var emailHeader = "_oc-6";
export var emailIframe = "_oc-3";
export var emailInfoIcon = "_oc-9";
export var emailShortenedSummary = "_oc-e";
export var infoDropdown = "_oc-0";
export var infoRowBoundedContent = "_oc-d";
export var internal = "_oc-5";
export var merchant = "_oc-8";
export var messageInputContainer = "_oc-h";
export var normal = "_oc-7";
export var replyCard = "_oc-f";
export var subtleButton = "_oc-1";
export var subtleButtonIconContainer = "_oc-2";
export var toggleViewRepliesButton = "_oc-c";
export var wrappingText = "_oc-g";